/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for joining a team of a public user event with its join code.
 * @export
 * @interface TeamJoin
 */
export interface TeamJoin {
    /**
     * 
     * @type {string}
     * @memberof TeamJoin
     */
    join_code: string;
}

/**
 * Check if a given object implements the TeamJoin interface.
 */
export function instanceOfTeamJoin(value: object): value is TeamJoin {
    if (!('join_code' in value) || value['join_code'] === undefined) return false;
    return true;
}

export function TeamJoinFromJSON(json: any): TeamJoin {
    return TeamJoinFromJSONTyped(json, false);
}

export function TeamJoinFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamJoin {
    if (json == null) {
        return json;
    }
    return {
        
        'join_code': json['join_code'],
    };
}

export function TeamJoinToJSON(json: any): TeamJoin {
    return TeamJoinToJSONTyped(json, false);
}

export function TeamJoinToJSONTyped(value?: TeamJoin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'join_code': value['join_code'],
    };
}

